// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2NyN-","errorLogs":"EditorFooter_errorLogs__UVwRq"};